import { ref, computed, onMounted, onUnmounted } from "vue";

export default function useIsMobile(breakpoint = 991) {
  // 儲存目前視窗寬度
  const width = ref(typeof window !== "undefined" ? window.innerWidth : 0);

  // resize 時更新 width
  const onResize = () => {
    width.value = window.innerWidth;
  };

  onMounted(() => {
    window.addEventListener("resize", onResize);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", onResize);
  });

  // 計算布林：寬度 <= 991 為 true
  const isMobile = computed(() => width.value <= breakpoint);

  return { isMobile };
}
